
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M12 8C13.1046 8 14 7.10457 14 6C14 4.89543 13.1046 4 12 4C10.8954 4 10 4.89543 10 6C10 7.10457 10.8954 8 12 8Z' fill='#323232'/><path d='M21 14.94C21 14.44 20.64 14.01 20.15 13.96C18.27 13.75 16.66 12.83 15.4 11.33L14.06 9.73C13.68 9.26 13.12 9 12.53 9H11.48C10.89 9 10.33 9.26 9.95 9.72L8.61 11.32C7.36 12.82 5.74 13.74 3.86 13.95C3.36 14.01 3 14.44 3 14.94C3 15.54 3.53 16.01 4.13 15.94C6.43 15.67 8.45 14.55 10 12.75V15L6.24 16.5C5.59 16.76 5.08 17.33 5.01 18.03C4.91 19.1 5.74 20 6.79 20H9V19.5C9 18.12 10.12 17 11.5 17H14.5C14.78 17 15 17.22 15 17.5C15 17.78 14.78 18 14.5 18H11.5C10.67 18 10 18.67 10 19.5V20H17.1C17.95 20 18.75 19.46 18.95 18.63C19.16 17.74 18.68 16.87 17.87 16.55L14 15V12.75C15.56 14.55 17.57 15.66 19.87 15.94C20.47 16 21 15.54 21 14.94Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-self-improvement`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSelfImprovement

    ```js
    <b-new-b-icon-self-improvement />
    ```
</docs>


